import {field} from "../../stem-core/state/StoreField";
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {SocialAccountProvider} from "./SocialAccountStore";
import {UserProfile} from "./UserProfileStore";
import {SocialAccount} from "./SocialAccountStore";
import {Jurisdiction} from "./JurisdictionStore";
import {Merchant} from "./MerchantStore";
import {StemDate} from "../../stem-core/time/Date";


@makeEnum
export class UserSessionSource extends BaseEnum {
    static PASSWORD;
    static PASSWORD_RESET;
    static SECURE_PASSWORD;
    static SOCIAL;
    static EMAIL_LINK;
    static EMAIL_SHORT_CODE;
    static EMAIL_LONG_CODE;
    static REGISTRATION;
    static CANCEL_CLOSE_ACCOUNT_TOKEN;
    static UNDO_CHANGE_EMAIL_TOKEN;
    static ADMIN_GENERATED;
    static MERCHANT_GENERATED;
}


@globalStore
export class UserSession extends BaseStore("UserSession") {
    @field("UserProfile") user: UserProfile;
    @field(String) key: string;
    @field(UserSessionSource) source: UserSessionSource;
    @field(SocialAccountProvider) provider: SocialAccountProvider;
    @field("SocialAccount") socialAccount: SocialAccount;
    @field(Date) createdAt: StemDate;
    @field(Date) expiresAt: StemDate;
    @field(Date) revokedAt: StemDate;
    @field(String) ip: string;
    @field(String) countryCode: string;
    @field("Jurisdiction") jurisdiction: Jurisdiction;
    @field(String) userAgent: string;
    @field("Merchant") originMerchant: Merchant;
    @field("Merchant") sharedWithMerchant: Merchant;
}
